import useModalResultStore, { payloadModal } from "@/store/useModalResult";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

export const useShowModalResult = () => {
  const { modalResultSet } = useModalResultStore();

  const successModal = (val: payloadModal) => {
    modalResultSet({
      show: true,
      title: val?.title,
      body: val?.body,
      onClickOK: val?.onClickOK,
      type: "success"
    });
  };

  const errorModal = (val: payloadModal) => {
    modalResultSet({
      show: true,
      title: val?.title,
      body: val?.body,
      onClickOK: val?.onClickOK,
      type: "error"
    });
  };

  return { successModal, errorModal };
};

export default function ModalResult() {
  const { show, title, body, modalResultSet, onClickOK,type } = useModalResultStore();

  const handleCloseButton = () => {
    modalResultSet({
      show: false,
      title: null,
      body: null,
      type: null
    });
  };

  return (
    <Modal
      open={show}
      closeIcon={false}
      footer={
        <Button
          onClick={() => {
            if (onClickOK) {
              onClickOK();
            }

            handleCloseButton();
          }}
          type="primary"
        >
          OK
        </Button>
      }
    >
      <div className="flex items-start gap-4 p-4">
        {type === "success" && <CheckCircleOutlined className="text-[#DAFFD6] text-2xl" />}
        {type === "error" && <CloseCircleOutlined className="text-[#F5222D] text-2xl" />}
        <div className="flex flex-col gap-2">
          <p className="font-semibold">{title}</p>
          <p className="text-sm" dangerouslySetInnerHTML={{__html: body as string}}/>
        </div>
      </div>
    </Modal>
  );
}
